import React, { Component } from 'react'

export default class Donate extends Component {
    render() {
        return (
            <div className="container mt-5 pt-5">
                <div className="row">
                    <div className="container-fluid donate__container">
                        <h2 className="donate__head mb-4">My Donation</h2>
                        <p>Thank you for your decision to donate to us</p>
                        <p>please click on the donate button</p>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                        <input type="hidden" name="cmd" value="_s-xclick" />
                        <input type="hidden" name="hosted_button_id" value="K76DRSF9AZRWE" />
                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                        <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                        </form>

                    </div>
                </div>
            </div>
        )
    }
}
